import axios from 'axios';
import Vue from 'vue';
import { $axios } from './axios-instance';

const API_URL = process.env.VUE_APP_FULFILLMENT_API_BASE_URL;

const state = {
    orderTrackingInfo: {},
    orderId: '',
    orderById: {},
    allOrderIds: [],
};

const mutations = {
    SET_ORDER_ID(state, orderId) {
        state.orderId = orderId;
    },
    SET_ORDER_TRACKING_INFO(state, orderTrackingInfo) {
        state.orderTrackingInfo = orderTrackingInfo;
    },
    SET_USER_ORDER(state, item) {
        Vue.set(state.orderById, item.id, item);
        if (state.allOrderIds.includes(item.id)) return;
        state.allOrderIds.push(item.id);
    },
};

const actions = {
    setOrderId({ commit }, id) {
        commit('SET_ORDER_ID', id);
    },
    fetchOrderTrackingInfo: async ({ commit, state }, { orderId }) => {
        if (!orderId) {
            orderId = state.orderId;
        }
        if (orderId) {
            commit('SET_ORDER_ID', orderId);
            try {
                const response = await axios.get(
                    `${API_URL}/checkout/order/${state.orderId}`
                );
                commit('SET_ORDER_TRACKING_INFO', response.data);
            } catch (error) {
                console.log(error);
            }
        }
    },
    fetchUserOrders: async ({ commit }) => {
        const response = await $axios.get('/checkout/order/user', {
            withCredentials: true,
        });
        Object.values(response.data).forEach((item) => {
            commit('SET_USER_ORDER', item);
        });
    },
    handlePayPalCallback: async (_, { token, PayerID, success }) => {
        await axios.post(`${API_URL}/checkout/order/checkout/callback`, {
            token,
            PayerID,
            success,
        });
    },
};

const getters = {
    orderTrackingInfo: (state) => {
        return state.orderTrackingInfo;
    },
    orderById: (state) => (id) => {
        return state.orderById[id];
    },
    orderList: (state, getters) => {
        return state.allOrderIds.map((id) => {
            if (id) {
                return getters.orderById(id);
            } else {
                return {};
            }
        });
    },
};

export default { state, mutations, actions, getters };
